export default "__VITE_ASSET__COtCeE2T__"